import { safeHref } from "@rhema/format";
import type { Platform } from "./types";

/**
 * Opens a link from a message outside Rhema. Only web and email addresses are opened, checked again
 * here whatever the caller already checked. The desktop and mobile apps hand it to the system
 * browser or mail app. The web app opens a new tab that cannot reach back into Rhema.
 */
export function openLink(platform: Platform, href: string): void {
  const safe = safeHref(href);
  if (!safe) return;
  if (platform.native) {
    void platform.openExternal(safe).catch(() => undefined);
    return;
  }
  if (safe.startsWith("mailto:")) {
    // A mail link starts the mail app and leaves the page where it is.
    window.location.assign(safe);
    return;
  }
  window.open(safe, "_blank", "noopener,noreferrer");
}
